import { webApi } from "../../../../core/http/httpThunks";
import { EpsTrendApiResponse } from "../types";

export const getSecurityEpsTrendApi = (userId: string, symbol: string, endpoint: string) => {
 // console.log("Poziva se getTradeApi sa:", { userId, divid });

  return webApi<EpsTrendApiResponse>({
    method: "GET",
    url: "reporting/getsecurityinfo",
    params: {
      userId,
      symbol,
      endpoint
    },
  });
};

export default getSecurityEpsTrendApi;
